import { Typography } from '@coolblue-development/becky';
import { AgentAllocation } from '../../../../models/AgentsAllocation';

interface SelectedAgentsListProps {
  selectedAgents: AgentAllocation[];
}

export const SelectedAgentsList = ({ selectedAgents }: SelectedAgentsListProps): JSX.Element => {
  return (
    <>
      <Typography variant="h3" mb={'4px'}>
        Selected agents
      </Typography>

      <Typography>You've selected {selectedAgents.length} agents:</Typography>

      <ul>
        {selectedAgents.map(agent => (
          <li key={agent.id}> {agent.username}</li>
        ))}
      </ul>
    </>
  );
};
